import { connect } from 'react-redux'
import { compose } from 'recompose'
import moment from 'moment'
import { SERVER_DATE } from 'src/constants/formats'
import { selectRentalPropertyDateOfTargetLTV } from 'src/store/selectors/home/equity'

const NotEnoughEquityContainer = compose(
  connect(state => {
    const dateOfTargetLTV = selectRentalPropertyDateOfTargetLTV(state)

    return {
      timeToTargetLTV: moment(dateOfTargetLTV, SERVER_DATE).fromNow()
    }
  })
)

export default NotEnoughEquityContainer
